@if (!(loading$ | async)) {
  <div class='cx-order-confirmation-message'>
    <div class="check-container">
      <div class="check"></div>
      <div class='label'>{{'checkoutOrderConfirmation.done' | cxTranslate}}</div>
    </div>
    <div class='title'>
      <div class='thanks'>{{ 'checkoutOrderConfirmation.thankYou' | cxTranslate }}</div>
      @if (isSequra && (order.status === 'ON_HOLD' || order.status === 'CANCELLED')) {
        <h1>{{'checkoutOrderConfirmation.thankYouTitleSequra' | cxTranslate }}</h1>
        <div
        class='success'>{{'checkoutOrderConfirmation.thankYouSequra' | cxTranslate }}</div>
      } @else {
        <h1>{{'checkoutOrderConfirmation.thankYouTitle' | cxTranslate }}</h1>
        <div
        class='success'>{{'checkoutOrderConfirmation.thankYouExit' | cxTranslate}}</div>
      }
    </div>
    <p class='text'>
      {{ 'checkoutOrderConfirmation.invoiceHasBeenSentByEmail' | cxTranslate: { email: order?.customer?.contactEmail } }}
    </p>
  </div>
  <div class='order'>
    <div><span
      class='label'>{{'checkoutOrderConfirmation.orderNumber' | cxTranslate}}</span><span> {{order?.code}}</span></div>
      <div><span
        class='label'>{{'checkoutOrderConfirmation.placedOn' | cxTranslate}} </span><span>{{order?.created | customDate}}</span>
      </div>
      <div><span
        class='label'>{{'checkoutOrderConfirmation.paymentMethod' | cxTranslate}} </span><span>{{order?.paymentMode?.name}}</span>
      </div>
      <div id="trustedShopsCheckout" class="d-none">
        <span id="tsCheckoutOrderNr">{{order?.code}}</span>
        <span id="tsCheckoutBuyerEmail">{{order?.deliveryAddress?.email}}</span>
        <span id="tsCheckoutOrderAmount">{{order?.totalPriceWithTax?.value}}</span>
        <span id="tsCheckoutOrderCurrency">{{order?.totalPriceWithTax?.currencyIso}}</span>
        <span id="tsCheckoutOrderPaymentType">{{order?.paymentMode?.name}}</span>
        <span id="tsCheckoutOrderEstDeliveryDate">{{order?.created | cxDate:'yyyy-MM-dd'}}</span>
        <!-- product reviews start -->
        @for (entry of order?.entries; track entry) {
          <span class="tsCheckoutProductItem">
            <span class="tsCheckoutProductUrl">{{location?.origin}}{{entry?.product?.url}}</span>
            <span class="tsCheckoutProductImageUrl">{{entry?.product?.images?.PRIMARY?.product?.url}}</span>
            <span class="tsCheckoutProductName">{{entry?.product?.name}}</span>
            <span class="tsCheckoutProductSKU">{{entry?.product?.code}}</span>
            <span class="tsCheckoutProductGTIN">{{entry?.product?.code}}</span>
            <span class="tsCheckoutProductMPN">{{entry?.product?.code}}</span>
            <span class="tsCheckoutProductBrand">{{entry?.product?.manufacturer}}</span>
          </span>
        }
        <!-- product reviews end -->
      </div>
    </div>
  }

  <app-custom-newsletter></app-custom-newsletter>

  <div class='go-back'>
    <a [routerLink]="{ cxRoute: '/' } | cxUrl">
      {{'checkoutOrderConfirmation.goBack' | cxTranslate}}
    </a>
  </div>

